module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vleg3-41708b21a505204495aeaa6b557853fb.jpg";